import { defineComponent as _defineComponent } from 'vue'

import { useRoute } from 'vue-router'
import { getTrainsUrlV2 } from "@/api/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'trainskf',
  setup(__props) {

const route = useRoute()
const _getTrainsUrl = async () => {
  const res = await getTrainsUrlV2({
    iccid: route.params.iccid,
  });
  console.log(res);
  if (res.result === '' || res.result === null || res.result === undefined) return;
  window.location.href = res.result;
};
_getTrainsUrl();

return (_ctx: any,_cache: any) => {
  return null
}
}

})